import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { HierarchyEntityMifirDecisionMaker } from '../../Models/Domains/DecisionMaker/HierarchyEntityMifirDecisionMaker';

declare var IS_RUNNING_IN_APP_POOL;

export class DecisionMakerClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(hierarchyId: string): Promise<Array<HierarchyEntityMifirDecisionMaker>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Account/DecisionMaker/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId }

    return AjaxWrapper.get<Array<HierarchyEntityMifirDecisionMaker>, any>(url, data);
  }
}

